/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * 31 Milk St # 960789 Boston, MA 02196 USA.
 *
 * Copyright (c) 2023-2026 (original work) Open Assessment Technologies SA;
 */

import dynamicKeys from '@/locale/dynamicKeys.js';
import * as Types from '../../core/model/types.js'; // eslint-disable-line no-unused-vars
import { __ } from '@oat-sa-private/ui-core';

/**
 * Get the translated UI label for a status
 * @param {Types.DeliveryExecution} deliveryExecution
 * @returns {String}
 */
export function getDxStatusLabel(deliveryExecution = {}) {
    const status = deliveryExecution.status || 'unknown';
    return dynamicKeys()[`status-${status}-label`].toLocaleUpperCase(__.getLocale() || void 0);
}

/**
 * Convert interactions type to ACS interactions
 * @param {Types.Interaction[]} interactions
 * @param {String} action - from actionsList
 * @returns {Types.ACSInteraction[]}
 */
export function interactionsToAcs(interactions, action) {
    if (!interactions || !action) {
        throw new TypeError('interactionsToAcs requires "interactions" and "action" to be defined');
    }

    const now = new Date().toISOString();

    return interactions.map(interaction => ({
        resource_link_id: interaction.resourceLinkId || '',
        delivery_execution_id: interaction.deliveryExecution.id,
        userName: interaction.user.name,
        sub: interaction.user.id,
        action,
        incident_time: now
    }));
}
